import {AfterViewInit, Component, OnDestroy, OnInit, ChangeDetectorRef} from '@angular/core';
import {GoBackButtonService} from '../../../services/go-back-button.service';
import {JsonClientService} from '../../../shared/json-client';
import {NotificationService} from '../../../services/notification.service';
import {AlternativeDatatablesComponent} from '../../../shared/alternative-datatables/alternative-datatables.component';
import {AlternativeDatatablesInterface} from '../../../shared/alternative-datatables/alternative-datatables.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {TemplateService} from '../../../services/template.service';
import {Subject, Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {environment} from '../../../../environments/environment';


@Component({
    templateUrl: './requests.component.html',
    styleUrls: ['./requests.component.scss'],
    standalone: false
})
export class InstatekaRequestsComponent extends AlternativeDatatablesComponent
  implements AlternativeDatatablesInterface, OnInit, OnDestroy, AfterViewInit {

  public head;

  public filter_columns = {};
  public form: UntypedFormGroup;
  public filter: string;

  public housing_id = null;
  private parasites = true;

  public filterSubject: Subject<void> = new Subject<void>();
  private filterSubscription: Subscription;
  private formSubscription: Subscription;

  public current_page = 1;

  public urlLead = environment.apiServer + 'restful/instateka_xml';

  public count;
  public rows;
  public statistics = {};

  public sort: { [key: string]: string } = {};

  public current_flat: any = null;

  public set data(value) {
    this.count = value['count'];
    this.rows = value['rows'];
  }

  constructor(public http: JsonClientService,
              private notify: NotificationService,
              public goBack: GoBackButtonService,
              private router: Router,
              private fb: UntypedFormBuilder,
              public activatedRoute: ActivatedRoute,
              private template: TemplateService,
              private cdr: ChangeDetectorRef) {
    super(router, activatedRoute, fb, http);

    this.filterSubscription = this.filterSubject
      .pipe(debounceTime(500))
      .subscribe(_ => this.onFilterChanges());
  }

  bSet() {
    this.goBack.header = '<h2>Инстатека заявки</h2>';
    this.template.setHeader('Инстатека заявки');
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      'date_from': [this.activatedRoute.snapshot.queryParams['date_from'] || ''],
      'date_to': [this.activatedRoute.snapshot.queryParams['date_to'] || ''],
    });

    this.head = [
      {'name': 'inst_id', 'value': '', 'caption': '№', 'input': true, 'sort': true, 'width': '50px'},
      {'name': 'time_created', 'value': '', 'caption': 'Дата создания', 'input': false, 'sort': true},
      {'name': 'sa_caption', 'value': '', 'caption': 'СА Организация', 'input': true, 'sort': false},
      {'name': 'author_fio', 'value': '', 'caption': 'СА Пользователь', 'input': true, 'sort': false},
      {'name': 'fio', 'value': '', 'caption': 'Клиент', 'input': true, 'sort': false},
      {'name': 'value', 'value': '', 'caption': 'Сумма кредита', 'input': true, 'sort': false},
      {'name': 'last_update', 'value': '', 'caption': 'Обновлена', 'input': false, 'sort': true},
      {'name': 'status_name', 'value': '', 'caption': 'Статус', 'input': false, 'sort': false,
        'select': [
          {'caption': 'Все', 'id': ''},
          {'caption': 'В работе', 'id': 'В работе'},
          {'caption': 'Одобрено', 'id': 'Одобрено'},
          {'caption': 'Отказ', 'id': 'Отказ'},
          {'caption': 'Кредит выдан', 'id': 'Кредит выдан'},
        ]},
    ];

    this.head = this.head.map(x => {
      x.value = this.activatedRoute.snapshot.queryParams[x.name] || x.value;
      return x;
    });
    if (this.activatedRoute.snapshot.queryParams['sort_name']) {
      this.sort[this.activatedRoute.snapshot.queryParams['sort_name']] = this.activatedRoute.snapshot.queryParams['sort_key'];
    }

    this.formSubscription = this.form.valueChanges
      .subscribe(_ => this.filterSubject.next());

    for (const el of this.head) {
      this.form.addControl(el.name, new UntypedFormControl(el.value));
    }

    this.filter = this.activatedRoute.snapshot.queryParams['global_search_string'] || '';
    this.onInitCall();
  }

  ngOnDestroy() {
    super.ngOnDestroy();

    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }

    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  onFilterChanged(): void {
    this.data = this.activatedRoute.snapshot.data['data'];
    this.statistics = this.activatedRoute.snapshot.data['statistics'];
    this.current_page = +this.activatedRoute.snapshot.queryParams['page'] || 1;
  }

  onFilterChanges(text = null) {

    if (text !== null) {
      this.filter = text;
    }

    this.filter_columns = {};
    for (const el of this.head) {
      if (!this.form.get(el.name).value.length) {
        continue;
      }
      this.filter_columns[el.name] = this.form.get(el.name).value;
    }
    if (this.filter !== '') {
      this.filter_columns['global_search_string'] = this.filter;
    }
    if (this.sort) {
      this.filter_columns['sort_name'] = Object.keys(this.sort)[0];
      this.filter_columns['sort_key'] = this.sort[this.filter_columns['sort_name']];
    }
    if (this.parasites) {
      return this.parasites = !this.parasites;
    }
    this.bSet();
    this.router.navigate(['instateka'], {
      queryParams: this.getQueryParams(),
    });
  }

  getQueryParams() {
    const query_params = {}, cols = [...this.head];
    cols.push({
      name: 'date_from',
    }, {
      name: 'date_to',
    });
    for (const el of cols) {
      let _val = this.form.get(el.name).value;
      if (!_val.length) {
        continue;
      }
      if (_val === 'true' || _val === 'false') {
        _val = _val === 'true';
      }
      query_params[el.name] = _val;
    }
    if (this.sort) {
      query_params['sort_name'] = Object.keys(this.sort)[0];
      query_params['sort_key'] = this.sort[query_params['sort_name']];
    }
    if (this.filter !== '') {
      query_params['global_search_string'] = this.filter;
    }
    return query_params;
  }

  prepareSort(column_name: string) {
    for (const key in this.sort) {
      if (column_name !== key) {
        delete this.sort[key];
      }
    }
  }

  sortChange(column_name: string) {
    this.prepareSort(column_name);
    this.sort[column_name] = !this.sort[column_name] || ('desc' === this.sort[column_name]) ? 'asc' : 'desc';
    this.onFilterChanges();
  }

  ngAfterViewInit() {
    this.bSet();
    this.goBack.goScroll();
    this.cdr.detectChanges();
  }
}
